<template>
  <div
      class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded"
      :class="[color === 'light' ? 'bg-white' : 'bg-yellow-900 text-white']"
  >
    <div class="rounded-t mb-0 px-4 py-3 border-0">
      <div class="px-3 text-center flex justify-between">
        <h3
            class="font-semibold text-lg"
            :class="[color === 'light' ? 'text-blueGray-700' : 'text-white']"
        >
          {{ locker.name }} - {{ $t('drawers') }}
        </h3>
      </div>
    </div>
    <div class="block w-full overflow-x-auto">
      <!-- Projects table -->
      <table class="items-center w-full bg-transparent border-collapse">
        <thead>
        <tr>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('status') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('free') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('solenoid_state') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('door_state') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('size') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('slave_id') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          >
            {{ $t('solenoid_id') }}
          </th>
          <th
              class="px-6 align-middle py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left"
              :class="[
                  color === 'light'
                    ? 'bg-gray-50 text-blueGray-500 border-blueGray-100'
                    : 'bg-yellow-800 text-yellow-300 border-emerald-700',
                ]"
          ></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(drawer, index) in drawers">
          <tr v-if="drawer.id > 0" :key="index">
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.blackout_state === 0">
                <i class="fas fa-circle text-emerald-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.blackout_state === 1">
                <i class="fas fa-circle text-orange-500 mr-2"></i>
              </div>
              <div v-else>
                <i class="fas fa-circle text-red-500 mr-2"></i>
              </div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.blackout_state === 1 || drawer.blackout_state === null">
                <i class="fas fa-question-circle text-gray-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.awaiting_operation === 0">
                <i class="fas fa-circle text-emerald-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.awaiting_operation === 1">
                <i class="fas fa-circle text-red-500 mr-2"></i>
              </div>
              <div v-else>
                <i class="fas fa-question-circle text-gray-500 mr-2"></i>
              </div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.blackout_state === 1 || drawer.blackout_state === null">
                <i class="fas fa-question-circle text-gray-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.solenoid_state === 0">
                <i class="fas fa-circle text-gray-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.solenoid_state === 1">
                <i class="fas fa-circle text-emerald-500 mr-2"></i>
              </div>
              <div v-else>
                <i class="fas fa-question-circle text-gray-500 mr-2"></i>
              </div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.blackout_state === 1 || drawer.blackout_state === null">
                <i class="fas fa-question-circle text-gray-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.door_state === 0">
                <i class="fas fa-door-closed text-gray-500 mr-2"></i>
              </div>
              <div v-else-if="drawer.door_state === 1">
                <i class="fas fa-door-open text-red-500 mr-2"></i>
              </div>
              <div v-else>
                <i class="fas fa-question-circle text-gray-500 mr-2"></i>
              </div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.size_code.toUpperCase() === ''">-</div>
              <div v-else>{{ drawer.size_code.toUpperCase() }}</div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.slave_id === ''">-</div>
              <div v-else>{{ drawer.slave_id }}</div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4"
            >
              <div v-if="drawer.solenoid_id === ''">-</div>
              <div v-else>{{ drawer.solenoid_id}}</div>
            </td>
            <td
                class="border-t-0 px-6 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-4 text-right"
            >
              <drawers-dropdown v-bind:index="index"/>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import DrawersDropdown from "@/components/Dropdowns/Manager/DrawersDropdown.vue";
import AuthService from "../../../services/auth.service";

export default {
  name: 'Lockers',
  data() {
    return {
      drawers: [],
      locker: this.$parent.$props.locker,
      AuthService
    };
  },

  mounted: function () {
    AuthService.getDrawersByLockerId(this.locker.id).then(
        response => {
          this.drawers = response.data.message;
        }
    );
    window.setInterval(() => {
      AuthService.getDrawersByLockerId(this.locker.id).then(
          response => {
            this.drawers = response.data.message;
          }
      );
    }, 20000)
  },

  components: {
    DrawersDropdown
  },

  props: {
    color: {
      default: "light",
      validator: function (value) {
        // The value must match one of these strings
        return ["light", "dark"].indexOf(value) !== -1;
      },
    },
  },
};
</script>
